import { useSelector, useDispatch } from "react-redux";
import { clearCatalogLastScrollY, clearCatalogProductSliderLastScrollX, setCatalogLastScrollY, setCatalogProductSliderLastScrollX } from "@actions/navigation-actions";

export function useCatalogNavigation() {
  return useSelector((state) => state.navigation.catalog);
}

export function useCatalogLastScrollY() {
  return useSelector((state) => state.navigation.catalog.lastScrollY);
}

export function useSetCatalogLastScrollY() {
  const dispatch = useDispatch();

  return (lastScrollY) => dispatch(setCatalogLastScrollY(lastScrollY));
}

export function useClearCatalogLastScrollY() {
  const dispatch = useDispatch();

  return () => dispatch(clearCatalogLastScrollY());
}

export function useCatalogProductSliderLastScrollX(context) {
  const catalogNavigation = useSelector((state) => state.navigation.catalog.productSlider);

  if (!context || !catalogNavigation?.[context]) return 0;

  return catalogNavigation?.[context]?.lastScrollX;
}

export function useSetCatalogProductSliderLastScrollX() {
  const dispatch = useDispatch();

  return (lastScrollX, context) => dispatch(setCatalogProductSliderLastScrollX(lastScrollX, context));
}

export function useClearCatalogProductSliderLastScrollX() {
  const dispatch = useDispatch();

  return (context) => dispatch(clearCatalogProductSliderLastScrollX(context));
}
